import {
    DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_REQUEST,
    DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_SUCCESS,
    DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_FAILURE
  } from "../types/debit-credit-note-bill-base-report-types";
  
  const initialState = {
    debitCreditNoteBillBaseReport: {},
    loading: false,
    error: null,
  };
  
  const debitCreditNoteReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_SUCCESS: {
        return {
          ...state,
          debitCreditNoteBillBaseReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default debitCreditNoteReportReducer;
  